<template>
<div id="app">
    <Header v-if="isShow()"   />
    <router-view />
</div>
</template>

<script>
import Header from '@/components/common/Header.vue';
import { ConstantUtil } from '@/utils/ConstantUtil';
import { sendWebSocketObj } from '@/utils/websocket';

export default {
    name: 'App',
    components: {
        Header,
    },
    data() {
        return {
            socketTimer: undefined,
        };
    },
    computed: {
        webSocketIsConnected() {
            return this.$store.state.socket.isConnected;
        },
    },
    mounted() {
        this.startSocketTimer();
    },
    destroyed() {
        clearInterval(this.socketTimer);
        this.socketTimer = undefined;
    },
    methods: {
        isShow () {
            return !['TtDEX', 'Reg', 'Login', 'SetFundPassword', 'GetToken', 'Ttdex'].includes(this.$route.name);
        },
        startSocketTimer (){
            clearInterval(this.socketTimer);
            this.socketTimer = setInterval(
                () => {
                    if (this.webSocketIsConnected){
                        sendWebSocketObj(this, 'ping', []);
                    }
                },
                ConstantUtil.interval.socketTimer,
            );
        }
    },
};
</script>

<style>
@import '../static/style/common.css';
@import '../static/style/reset.css';
@import '../static/style/preset.less';

#app {
    display: flex;
    flex-direction: column;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue